import { cepFill, type AddressValue } from '@loot/shared';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../../api.ts';

/**
 * Consulta de CEP pelo servidor, com as mensagens para a tela (ADR 0029). Só o CEP sai do sistema.
 * Quem chama recebe apenas o que a consulta trouxe com conteúdo; falha não muda nada no formulário.
 */
export function useCepLookup() {
  const { t } = useTranslation();
  const query = useMutation({
    mutationFn: (cep: string) => api.get<Partial<AddressValue>>(`/address/postal-code/${cep}`),
  });
  const error = !query.error
    ? null
    : query.error instanceof ApiError && query.error.status === 404
      ? t('forms.address.notFound')
      : query.error instanceof ApiError && query.error.status === 400
        ? t('forms.address.invalidCep')
        : t('forms.address.unavailable');
  return {
    lookup: (cep: string, onFound: (found: Partial<AddressValue>) => void) =>
      query.mutate(cep, { onSuccess: (found) => onFound(cepFill(found)) }),
    pending: query.isPending,
    error,
  };
}
